module.exports = __webpack_public_path__ + "img/2.5b574b50.jpg";